import { useContext, useEffect, useReducer, useState } from "react";
import { AppContext } from "../../context/AppProvider";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  serverTimestamp,
  setDoc,
  where,
} from "firebase/firestore";
import { basicReducer } from "../../util/General";
import { cardDivStyle } from "../../styles/styles";

const RaceVotingPage = () => {
  const appState = useContext(AppContext);
  const [categories, setCategories] = useState();
  const [firstRun, setFirstRun] = useState(true);
  const [beforeTeamData, setBeforeTeamData] = useState(true);
  const [submitInProgress, setSubmitInProgress] = useState();
  const [teamCache, dispatchTeamCacheAction] = useReducer(basicReducer, {});
  const [voteChoices, dispatchVoteAction] = useReducer(basicReducer, {});
  const [previousChoices, dispatchPreviousVoteOption] = useReducer(
    basicReducer,
    {}
  );

  useEffect(() => {
    if (firstRun) {
      setFirstRun(false);

      if (appState.firebase && appState.firebase.db) {
        const docRef = doc(
          appState.firebase.db,
          "contest_categories",
          "9rNjsuhhucBUnbt1On0r"
        );

        getDoc(docRef)
          .then((docSnap) => {
            setCategories(docSnap.data());
          })
          .catch((err) => {
            window.alert(`Error loading categories ${err}`);
          });

        reloadChoices();
      }
    }
  }, []);

  const reloadChoices = () => {
    if (appState.firebase && appState.firebase.db) {
      const voteRef = doc(
        appState.firebase.db,
        "race_votes",
        appState.live.uid
      );
      getDoc(voteRef)
        .then((docSnap) => {
          let previousData = docSnap.data();
          if (previousData.votes)
            dispatchPreviousVoteOption({
              type: "merge",
              data: previousData.votes,
            });
        })
        .catch((err) => {
          console.log(`Error loading previous votes ${err}`);
        });
    }
  };

  useEffect(() => {
    if (categories && categories.voting && beforeTeamData) {
      setBeforeTeamData(false);

      let categoryIds = [...Object.keys(categories.voting)];

      if (appState.firebase && appState.firebase.db) {
        const q = query(
          collection(appState.firebase.db, "teams"),
          where("registered_for", "array-contains-any", categoryIds)
        );

        getDocs(q).then((qSnap) => {
          qSnap.forEach((doc) => {
            dispatchTeamCacheAction({
              type: "update",
              key: doc.id,
              value: doc.data(),
            });
          });
        });
      }
    }
  }, [categories]);

  const getVoteChoiceCallback = (categoryId, choiceId) => {
    return (e) => {
      dispatchVoteAction({ type: "update", key: categoryId, value: choiceId });
    };
  };

  const derivedChoices = { ...previousChoices, ...voteChoices };

  const handleSubmit = (e) => {
    setSubmitInProgress(true);
    if (!submitInProgress) {
      const docRef = doc(appState.firebase.db, "race_votes", appState.live.uid);
      const uploadData = {
        updated: serverTimestamp(),
        uid: appState.live.uid,
        categories_id: "9rNjsuhhucBUnbt1On0r",
        cached: { user_nickname: appState.live.user_nickname },
        votes: derivedChoices,
      };
      setDoc(docRef, uploadData, { merge: true })
        .then((docRef) => {
          console.log("Vote updated successfully", docRef);
          reloadChoices();
          dispatchVoteAction({ type: "reset" });
          setSubmitInProgress(false);
        })
        .catch((err) => {
          window.alert(`Vote failed\n${err}`);
          setSubmitInProgress(false);
        });
    }
  };

  const teamRowMap = {};

  if (categories && categories.voting) {
    Object.keys(categories.voting).forEach((categoryId) => {
      teamRowMap[categoryId] = [];
      const categoryData = categories.voting[categoryId];
      let eligibleTeams = [];
      Object.keys(teamCache).forEach((teamId) => {
        const teamData = teamCache[teamId];
        if (
          teamData.team_name &&
          teamData.registered_for &&
          teamData.registered_for.includes(categoryId) &&
          teamData.car_photo
        ) {
          eligibleTeams.push(teamId);
        }
      });
      let teamRows = [];
      let oneRow = [];
      teamRows.push(oneRow);
      eligibleTeams.forEach((teamId) => {
        if (oneRow.length == 0) oneRow.push(teamId);
        else {
          oneRow.push(teamId);
          oneRow = [];
          teamRows.push(oneRow);
        }
      });
      teamRowMap[categoryId] = teamRows;
    });
  }

  return (
    <>
      <div style={cardDivStyle}>
        <h1>Voting!</h1>
        <p>
          Cast your votes for the categories below! Click submit at the bottom
          of the page when you are finished. You can edit your votes!
        </p>
      </div>
      {categories &&
        categories.voting &&
        Object.keys(categories.voting).map((categoryId) => {
          const categoryData = categories.voting[categoryId];
          return (
            <div style={cardDivStyle}>
              <h1>{categoryData.title}</h1>
              <p>{categoryData.desc}</p>
              <div style={{ margin: 0, padding: 0, width: "100%" }}>
                {teamRowMap[categoryId].map((teamRow) => {
                  return (
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                      }}
                    >
                      {teamRow.map((teamId) => {
                        const teamData = teamCache[teamId];
                        return (
                          <div
                            style={{
                              flex: "1",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "5px",
                            }}
                          >
                            <div>
                              <img
                                src={teamData.car_photo}
                                onClick={getVoteChoiceCallback(
                                  categoryId,
                                  teamId
                                )}
                                style={{
                                  maxWidth: "100%",
                                  height: "30vh",
                                  objectFit: "contain",
                                  border:
                                    derivedChoices[categoryId] === teamId
                                      ? "4px lightBlue solid"
                                      : "none",
                                }}
                              />
                              <br />
                              <span>{teamData.team_name}</span>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      {Object.keys(voteChoices).length > 0 && (
        <div style={cardDivStyle}>
          <button
            className="btn btn-success"
            disabled={submitInProgress}
            onClick={handleSubmit}
          >
            {submitInProgress ? "Submitting..." : "Submit"}
          </button>
        </div>
      )}
    </>
  );
};

export { RaceVotingPage };
